import vsComponent from './vsSlider';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
